import { maskProductsAmount } from './cart/cart-management.js';

let detailDiscontTable = document.querySelector('.detail-discount-table');

export default function () {
    const selector = '.product-counter';
    const itemCounters = document.querySelectorAll(selector);
    maskProductsAmount(`${selector} input`);

    itemCounters.forEach((counter) => {
        const inputField = counter.querySelector('input');

        if (counter.classList.contains("detail-amount")) {
            initUserControls(counter, inputField, true);
            if (detailDiscontTable) whichDiscount(1);
        } else {
            initUserControls(counter, inputField, false);
        }
    });
}
function initUserControls(counter, inputField, isDetail) {
    counter.querySelector('.plus').addEventListener('click', function () {
        inputField.value = Number(inputField.value) + 1;
        if (isDetail && detailDiscontTable) whichDiscount(+inputField.value);
    }, false);
    counter.querySelector('.plus').addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
            this.click();
        }
    }, false);

    counter.querySelector('.minus').addEventListener('click', function () {
        if (Number(inputField.value) > 1) {
            inputField.value = Number(inputField.value) - 1;
            if (isDetail && detailDiscontTable) whichDiscount(+inputField.value);
        }
    }, false);
    counter.querySelector('.minus').addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
            this.click();
        }
    }, false);
}

function whichDiscount(amount) {
    let whichRow = null;

    document.querySelectorAll('[data-discount-table-pcs]').forEach((data, index) => {
        const dataAttr = +data.getAttribute('data-discount-table-pcs');

        if (amount >= dataAttr) {
            whichRow = index;
        }

        data.addEventListener('click', function () {
            document.querySelector('.detail-amount input').value = +dataAttr;
            detailDiscontTable.querySelectorAll('tr').forEach(row => row.classList.remove('selected'));
            data.classList.add('selected');
        });
    });

    const rows = detailDiscontTable.querySelectorAll('tr');

    rows.forEach(row => row.classList.remove('selected'));

    if (whichRow || whichRow === 0) {
        rows.forEach((row, index) => {
            if (index === whichRow) {
                row.classList.add('selected');
            }
        });
    }
}